<div fxFlex="100"> 
    <calsoft-custom-excel-mapper [route]="'/googleCalender'"  [serviceName]="'uploadGoogleCalendar'"
    [title]="'Import XL'" [primaryTitle]="'Import XL'" [serviceUrl]="'googleCalendarServiceAccountService'"
    [type]="'0'" [mapper]="mapper"></calsoft-custom-excel-mapper>
</div>